import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ElementRef, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils.service';
import { Certificate } from '../../certificate.model';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-edit-certificate',
    templateUrl: './add-edit-certificate.component.html',
    styleUrls: ['./add-edit-certificate.component.scss'],
    standalone: false
})
export class AddEditCertificateComponent implements OnInit {
  addCertificateForm!: FormGroup;
  type: string;
  id: number;
  certificate!: Certificate;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  productCtrl = new FormControl();
  filteredProducts: Observable<string[]>;
  products: any[];
  allProducts: any[];
  @ViewChild('productInput') productInput!: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  productsList!: any[];
  invalidProducts: boolean;
  invalidFiles!: boolean;
  fileIconOn: boolean;
  filesList: FileList | null = null;
  minDate: Date;
  isLoading = false;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddEditCertificateComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.type = data.type;
                this.id = data.id;
                this.minDate = new Date();
                this.minDate.setDate(this.minDate.getDate() + 1);
                this.invalidProducts  = false;
                this.fileIconOn = true;
                this.products = new Array<string>();
                this.user = this.authService.getUserData();
                this.allProducts = new Array<string>();
                if (this.type === 'Edit') {
                  this.getCertificate();
                }
                this.filteredProducts = this.productCtrl.valueChanges.pipe(
                  startWith(null),
                  map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
              }

  ngOnInit(): void {
    this.addCertificateForm = new FormGroup({
      description: new FormControl(this.certificate ?  this.certificate.description : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      expireDate: new FormControl(this.certificate ?  this.certificate.expirationDate : null, [Validators.required]),
      link: new FormControl(this.certificate ?  this.certificate.path : null, [Validators.required, Validators.pattern(this.utils.urlReg)]),
      file: new FormControl({ value: this.certificate ?  this.certificate.fileName : null, disabled: true }),
    });
    this.getAllProducts();
  }

  getAllProducts() {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword=', true).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
      }
      this.isLoading = false;
      });
  }

  getCertificate() {
    this.dataService.get('certificate/RetrieveCertificateById/' + this.data.id).then((data: any) => {
      if (data.statusCode === 200) {
        this.certificate = data.data;
        this.certificate.products.forEach(element => {
          this.products.push(element);
        });
        this.addCertificateForm.controls.description.setValue(this.certificate.description);
        this.addCertificateForm.controls.expireDate.setValue(this.certificate.expirationDate);
        if (this.certificate.type === 2) {
          this.fileIconOn = false;
          this.addCertificateForm.controls.link.setValue(this.certificate.path);
        } else if (this.certificate.type === this.utils.supportMaterials.Document || this.certificate.type === this.utils.supportMaterials.Image) {
          this.addCertificateForm.get('file')?.setValue(this.certificate.fileName);
        }
      }
    });
  }

  toggleIcon(type: string) {
    if (type === 'link' && this.fileIconOn) {
      this.invalidFiles = false;
      this.addCertificateForm.get('link')?.setValue(null);
      this.fileIconOn = !this.fileIconOn;
    } else if (type === 'file' && !this.fileIconOn) {
      this.filesList = null;
      this.fileIconOn = !this.fileIconOn;
      this.addCertificateForm.get('file')?.setValue('');
    }
  }

  closeDialog() {
    if (this.addCertificateForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  previewImage(fileList: any) {
    this.filesList = fileList;
    if (fileList.length > 0) {
      this.invalidFiles = false;
    }
    let name = '';
    for (let index = 0; index < fileList.length; index++) {
      if (index === 0) {
        name = fileList[index].name;
      } else {
        name = name + ',' + fileList[index].name;
      }
    }
    this.addCertificateForm.get('file')?.setValue(name);
  }

  onSubmit() {
    const date = new Date(this.addCertificateForm.get('expireDate')?.value);
    const timeOffsetInMS = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);

    if (this.products.length > 0) {
    } else {
      this.invalidProducts = true;
      if (this.filesList && this.filesList.length > 0) {
      } else {
        if (this.fileIconOn) {
          if (this.certificate) {
            if (this.certificate.fileName) {
            } else {
              this.invalidFiles = true;
              this.addCertificateForm.markAllAsTouched();
              return;
            }
          } else {
            this.invalidFiles = true;
            this.addCertificateForm.markAllAsTouched();
            return;
          }
        }
      }
    }
    if (this.filesList && this.filesList.length > 0) {
    } else {
      if (this.fileIconOn) {
        if (this.certificate && this.certificate.fileName) {
        } else {
          this.invalidFiles = true;
          this.addCertificateForm.markAllAsTouched();
          return;
        }
      }
    }
    if (this.fileIconOn) {
      this.addCertificateForm.get('link')?.setValue('https://link.link');
    }
    if (this.products.length === 0) {
      this.addCertificateForm.markAllAsTouched();
      return;
    }
    if (this.addCertificateForm.valid) {
      const productIds = [];
      for (let index = 0; index < this.products.length; index++) {
        const element = this.products[index];
        productIds.push(element.id);
      }
      if (this.type === 'Edit') {
        const payload = {
          certificateId: this.id,
          description: this.addCertificateForm.get('description')?.value,
          expirationDate: date,
          products: productIds,
        };
        this.utils.showProgressDialog();
        this.dataService.put('certificate/UpdateCertificate', payload, true).then((data: any) => {
          if (data.statusCode === 200) {
              if (this.fileIconOn) {
                if (this.filesList && this.filesList.length > 0) {
                  this.updateMaterial(payload);
                } else {
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message: 'Certificate updated successfully',
                      buttonText: 'Ok'
                    }
                  });
                  this.dialogRef.close(payload);
                }
              } else {
                if (this.addCertificateForm.get('link')?.value === this.certificate.path) {
                  this.dialogRef.close(payload);
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message: 'Certificate updated successfully',
                      buttonText: 'Ok'
                    }
                  });
                } else {
                  this.updateMaterial(payload);
                  this.dialogRef.close(payload);
                }
              }
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      } else if (this.type === 'Add') {
        const payload = {
          description: this.addCertificateForm.get('description')?.value,
          expirationDate: date,
          products: productIds,
        };
        this.utils.showProgressDialog();
        this.dataService.post('certificate/CreateCertificate', payload, true).then((data: any) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(data.data);
            const imagePayload = new FormData();
            imagePayload.append('file', this.filesList && this.filesList.length > 0 && this.fileIconOn ? this.filesList[0] : null);
            imagePayload.append('link', this.filesList && this.filesList.length > 0 && this.fileIconOn  ? null : this.addCertificateForm.get('link')?.value);
            imagePayload.append('certificateId', data.data.id);
            imagePayload.append('type', this.filesList && this.filesList.length > 0 && this.fileIconOn ? '4' : '2');

            this.dataService.put('certificate/UpdateCertificateFile', imagePayload, true).then((mediaData: any) => {
              if (mediaData.statusCode === 200) {
                this.dialogRef.close(payload);
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Success',
                    type: 'Success',
                    message: 'Certificate added successfully',
                    buttonText: 'Ok'
                  }
                });
              } else {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Error',
                    type: 'Error',
                    message: 'Something went wrong, Please try again!',
                    buttonText: 'Ok'
                  }
                });
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      }
    } else {
      this.addCertificateForm.markAllAsTouched();
    }
  }

  updateMaterial(payload: any) {
    const imagePayload = new FormData();
    imagePayload.append('file', this.filesList && this.filesList.length > 0 ? this.filesList[0] : null);
    imagePayload.append('link', this.filesList && this.filesList.length > 0 ? null : this.addCertificateForm.get('link')?.value);
    imagePayload.append('certificateId', this.id.toString());
    imagePayload.append('type', this.filesList && this.filesList.length > 0 ? '4' : '2');

    this.dataService.put('certificate/UpdateCertificateFile', imagePayload, true).then((mediaData: any) => {
      if (mediaData.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Certificate updated successfully',
            buttonText: 'Ok'
          }
        });
        this.dialogRef.close(payload);
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.products.includes(value.trim())) {
        this.products.push({
          id: Math.random(),
          name: value.trim()
        });

        this.invalidProducts = false;
      }
    }

    if (input) {
      input.value = '';
    }

    this.productCtrl.setValue(null);
  }

  remove(product: any, index: any): void {
    if (index >= 0) {
      this.products.splice(index, 1);
      if (this.products.length > 0) {
        this.invalidProducts = false;
      } else {
        this.invalidProducts = true;
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let productExist = false;
    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];
      if (element.id === event.option.value.id) {
        productExist = true;
      }
    }
    if (!productExist) {
      this.products.push(event.option.value);
    }
    this.productInput.nativeElement.value = '';
    this.productCtrl.setValue(null);
    if (this.products.length > 0) {
      this.invalidProducts = false;
    } else {
      this.invalidProducts = true;
    }
  }

  private _filter(value: any): any[] {
    return this.allProducts.filter(product => product.name.toLowerCase().includes(value));
  }

  searchProduct(event: any) {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword=' + this.productInput.nativeElement.value, true).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
      }
      this.isLoading = false;
      });
  }
}
